import React, { useEffect, useRef, useState } from 'react'
import { useCopyToClipboard } from 'react-use'
import { automateMonitoringService } from '../../Constants/Constants'
import { FiCopy , FiCheck} from 'react-icons/fi'
import { Button, CodeBlock, CustomSelect, Lightbox } from '../../Components'
import toast, { ToastIcon } from 'react-hot-toast'
import Tooltip from 'rc-tooltip'
import axios from 'axios'
import { useNavigate } from 'react-router-dom'

import './component-automation.css'
import { useSelector } from 'react-redux'

export function SetupComponentAutomation(props) {

	const effectCalled = useRef(false)
	const navigate = useNavigate()
    const { user , org } = useSelector((state) => state.auth)

	const [component, setComponent] = useState({
		value : props.component?.id,
		label : props.component?.name
	})
	const [components, setComponents] = useState([])
	const [monitorService, setMonitorService] = useState(null)
	const [state, copyToClipboard] = useCopyToClipboard();
	const [custom_webhook_url, setCustom_webhook_url] = useState('');
	const [isLoadingGeneratingWebhookURL, setIsLoadingGeneratingWebhookURL] = useState(false);
	const [isLoadingComponents, setIsLoadingComponents] = useState(false);
	const [recentlyCopied, setRecentlyCopied] = useState(false)


	useEffect(() => {
	  if(effectCalled.current ) return ;
	
	  	async function processTasks(){

			// Load the components list 
			getComponents({
				page : 0 , per_page : -1
			});

			let defaultService = (automateMonitoringService?.filter(x => x.is_active === true ) ?? [])[0]
			setMonitorService(defaultService)
			// Generate the custom webhook url 
			await generateWebhookURL({ 
				component_id : component?.value,
				statuspage_id : props.page_id ,
				monitoring_source_id : defaultService?.value
			})
		}
		processTasks();
		 
		effectCalled.current = true ;

	}, [])

	useEffect(() => {
		async function processTasks(){
			// Generate the custom webhook url 
			await generateWebhookURL({ 
				component_id : component?.value,
				statuspage_id : props.page_id ,
				monitoring_source_id : monitorService?.value
			})

			state = null ;
		}

		processTasks();
		
	}, [monitorService?.value])


	useEffect(() => {

		async function processTasks(){
			if(state?.error) toast.error('Webhook URL not copied!' ,{ position : 'bottom-right'});
			else if(state?.value) toast.success('Webhook URL copied!' , {
				position: "bottom-right"
			})
		}

		processTasks();

	}, [state])
	

	/**
	 * 
	 * @param {*} param0 
	 */
	const generateWebhookURL = ({ component_id , statuspage_id , monitoring_source_id }) => {

		return new Promise( async (resolve , reject) => {

			setIsLoadingGeneratingWebhookURL(true);
			
			if(component_id && statuspage_id && monitoring_source_id){
				
				let url = ``;
				url +=`${process.env.REACT_APP_API_URL}/automations/`
				url += `${monitoring_source_id }/`
				url += `${statuspage_id}/`
				url += `${component_id}`
				
				setCustom_webhook_url(url)
			}
			setIsLoadingGeneratingWebhookURL(false);
		})
	}

	/**
	 * 
	 * @param {*} param0 
	 * @returns 
	 */
	const getComponents = async ({ page , per_page}) => {

		return new Promise(async(resolve, reject) => { 

			setIsLoadingComponents(true)
			
			
			
			
			if (user && user.token && org && org?.id ) {
				
				let params = {
					page : page ,
					per_page : per_page,
					 
				}

				const token = user?.token;


				await axios.get(`${process.env.REACT_APP_API_URL}/statuspages/${props?.page_id}/components` , {
					params :params,
					headers: {
						'Authorization': `Bearer ${token}`
					},
				})
				.then( res => res.data )
				.then( data => {

					 

					setComponents(data.data)

					setIsLoadingComponents(false)
		
					resolve(data.data) 
		
				})
				.catch(error => {
					if(error?.response?.data?.error ==='USER_NOT_LOGIN'){
						navigate('/logout')
					}
					setIsLoadingComponents(false)
					if (error.response) {
						if(typeof error.response.data.statusCode!=='undefined' && error.response.data.statusCode===404){
						
							setComponents([])
						}
						reject((typeof error.response.data.error.message !=='undefined') ? error.response.data.error.message : error.response.data.message);
					} else {
						// Something happened in setting up the request that triggered an Error
						if(typeof error.message==='undefined' || error.message ===null || error.message!=="API_HAS_BEEN_CANCELED"){
								reject(`Something went wrong. Thank you try later.`)
						}
					}
				})
			}else{
				setIsLoadingComponents(false)
			}

		})
	}

	/**
	 * 
	 * @param {*} value 
	 */
	const onChangeComponents = async (COMPONENT_OBJECT) => {

		//console.log('value : ' , COMPONENT_OBJECT )
		setComponent(COMPONENT_OBJECT);

		// Generate the custom webhook url 
		await generateWebhookURL({ 
			component_id : COMPONENT_OBJECT?.value,
			statuspage_id : props.page_id ,
			monitoring_source_id : monitorService?.value
		})


		// let _components = [...components]
		// const index = _components.findIndex( x=> x.id === _component_id)
		// _components[index].component_status = value
		// setComponents(_components) 
	}

	/**
	 * 
	 * @param {*} URL 
	 */
	const copyWebhookURL = (URL) => {
		
		setRecentlyCopied(true)

		copyToClipboard(URL)

		setTimeout(() => {
			setRecentlyCopied(false)
		}, 1500);
	}

	/** GUDIE COMPONENTS  */
	const WebhookGuide = ({source }) =>{

		 

		switch (source ) {
			case 'pagerduty':
				const pagerduty_image_add_integration_webhook = require(`./../../assets/screenshot/pagerduty.com--add_integration_webhook.png`)
				return (
					<div className="guide-content">
						<div className="guide-step">
                            <div className="guide-step_title">Add the webhook integration to PagerDuty monitor</div>
							<div className="guide-step_body">
								<div className="screen-image" >
									<Lightbox 
										thumbail={pagerduty_image_add_integration_webhook}
										image={pagerduty_image_add_integration_webhook}
									/>
								</div>
								<ol>
									<li><a href="https://app.pagerduty.com/" target="_blanc">Log in to your PagerDuty account.</a></li>
                                    <li>From the top navbar, select <b>Services</b></li>
                                    <li>Than select <b>Service Directory</b> from the menu that appears below.</li>
                                    <li>Select the service you'd like to automate, or create a new one.</li>
                                    <li>In your service details page, select the <b>Integrations</b> tab</li>
                                    <li>Click on <b>+ Add an Extension</b> than <b>New Extension</b></li>
                                    <li>Select <b>Generic V2 Webhook</b> from the Extension type</li>
                                    <li>Add a name and the webhook URL of the component you just copied.</li>
									<li>Click <b>Save</b>.</li>
								</ol>
							</div>
						</div>
                    </div>
				)
			break;
			case 'site24x7':
				const site24x7_image_add_integration_webhook = require(`./../../assets/screenshot/site24x7.com--add_integration_webhook.png`)
				return (
					<div className="guide-content">
						<div className="guide-step">
                            <div className="guide-step_title">Add the webhook integration to Site24x7 monitor</div>
							<div className="guide-step_body">
								<div className="screen-image" >
									<Lightbox 
										thumbail={site24x7_image_add_integration_webhook}
										image={site24x7_image_add_integration_webhook}
									/>
								</div>
								<ol>
									<li><a href="https://www.site24x7.eu/login.html" target="_blanc">Log in to your Site24x7 account.</a></li>
                                    <li>Click <b>Admin</b> in the left side menu.</li>
                                    <li>Select <b>Third-Party Integrations</b> from the secondary menu that appears.</li>
									<li>Find the <b>Webhook</b> option, and click on <b>Integrate Now</b></li>
                                    <li>Add a name and the webhook URL of the component you just copied.</li>
                                    <li>Select <b>Post</b> as <b>HTTP Method</b></li>
                                    <li>Check the options <b>Post as JSON</b> and <b>Send Incident Parameters</b></li>
                                    <li>Scroll down to <b>Integration Level</b> section, select <b>Monitors</b></li>
                                    <li>In the <b>Select Monitors</b> field, select a monitor check that you have already added before</li>
									<li>Click <b>Save</b>.</li>
								</ol>
							</div>
						</div>
                    </div>
				)
			break;
			case 'hetrixtools':
				const hetrixtools_image_add_integration_webhook = require(`./../../assets/screenshot/hetrixtools.com--add_integration_webhook.png`)
				const hetrixtools_affect_integration_to_uptime_check = require(`./../../assets/screenshot/hetrixtools.com--affect_integration_to_uptime_check.png`)
				return (
					<div className="guide-content">
						<div className="guide-step">
                            <div className="guide-step_title">Add Webhook URL to HetrixTools</div>
							<div className="guide-step_body">
								<div className="screen-image" >
									<Lightbox 
										thumbail={hetrixtools_image_add_integration_webhook}
										image={hetrixtools_image_add_integration_webhook}
									/>
								</div>
								<ol>
									<li><a href="https://hetrixtools.com/login/" target="_blanc">Log in to your HetrixTools account.</a></li>
                                    <li>On the top right, click on your user avatar </li>
                                    <li>Select <b>Contact Lists</b> from the menu that appears below </li>
                                    <li>Click on <b>Add New Contact List</b></li>
                                    <li>Put a name, this name allows us to identify the contact list on the monitor settings</li>
                                    <li>In the same form, scroll down to the <b>Webhook</b> section</li>
                                    <li>Add the <b>Webhook URL</b> of the component you just copied</li>
                                    <li>Click <b>Add</b>.</li>
								</ol>
							</div>
						</div>
                        <div className="guide-step">
							<div className="guide-step_title">Affect the webhook contac list to uptime monitor</div>
							<div className="guide-step_body">
								<div className="screen-image" >
									<Lightbox 
										thumbail={hetrixtools_affect_integration_to_uptime_check}
										image={hetrixtools_affect_integration_to_uptime_check}
									/>
								</div>
								<ol>
                                    <li>Go back to <b>Uptime Monitors</b>.</li>
                                    <li>Find your selected uptime monitor</li> 
                                    <li>To edit the monitor setting, click the small pencil icon on the right ( under the <b>Action</b> column )</li>
                                    <li>Go to the <b>Contact List</b> section, and choose your <b>New Contact List</b> for the webhook you added in the previous step</li>
									<li>Click <b>Edit Monitor</b> to save your changes.</li> 
								</ol>
							</div>
						</div>
                    </div>
				)
			break;
			case 'runscope':
				const runscope_affect_integration_to_uptime_check = require(`./../../assets/screenshot/runscope.com--affect_integration_to_uptime_check.png`)
				return (
					<div className="guide-content">
						<div className="guide-step">
                        <div className="guide-step_title">Add the webhook integration to API check</div>
							<div className="guide-step_body">
								<div className="screen-image" >
									<Lightbox 
										thumbail={runscope_affect_integration_to_uptime_check}
										image={runscope_affect_integration_to_uptime_check}
									/>
								</div>
								<ol>
									<li><a href="https://www.runscope.com/signin" target="_blanc">Log in to your RunScope account.</a></li>
                                    <li>In Tests section, select your Api test</li>
                                    <li>Click <b>Editor</b> in the left side menu.</li>
                                    <li>Select <b>Test Settings</b> and click <b>Webhooks</b> from the menu that appears below </li>
                                    <li>Add the <b>Webhook URL</b> of the component you just copied</li>
                                    <li>Click <b>Save</b>.</li>									
								</ol>
							</div>
						</div>
                    </div>
				)
			break;
			case 'statuscake':
				const statuscake_image_add_integration_webhook = require(`./../../assets/screenshot/statuscake.com--add_integration_webhook.png`)
				const statuscake_affect_integration_to_uptime_check = require(`./../../assets/screenshot/statuscake.com--affect_integration_to_uptime_check.png`)
				return (
					<div className="guide-content">
						<div className="guide-step">
							<div className="guide-step_title">Add Webhook URL to StatusCake</div>
							<div className="guide-step_body">
								<div className="screen-image" >
									<Lightbox 
										thumbail={statuscake_image_add_integration_webhook}
										image={statuscake_image_add_integration_webhook}
									/>
								</div>
								<ol>
									<li><a href="https://app.statuscake.com/Login/" target="_blanc">Log in to your StatusCake account.</a></li>
                                    <li>Click <b>ALERTING</b> section in the left side menu.</li>
									<li>Select <b>Contact Groups</b> and then <b>New Contact Group</b> from the secondary menu that appears.</li>
                                    <li>In the form, add the <b>Group Name</b> </li>
                                    <li>Scroll down to the end of the form and add the <b>Webhook URL</b> of the component you just copied</li>
									<li>Select <b>Post</b> as the <b>Webhook Method</b></li>
                                    <li>Click <b>Save Now</b>.</li>
									
								</ol>
							</div>
						</div>
                        <div className="guide-step">
							<div className="guide-step_title">Affect the webhook integration to uptime check</div>
							<div className="guide-step_body">
								<div className="screen-image" >
									<Lightbox 
										thumbail={statuscake_affect_integration_to_uptime_check}
										image={statuscake_affect_integration_to_uptime_check}
									/>
								</div>
								<ol>
                                    <li>Click <b>MONITORING</b> section in the left side menu.</li>
									<li>Select <b>Uptime Monitoring</b> and then <b>All Tests</b> from the secondary menu that appears.</li>
									<li>Find the Uptime test (uptime check).</li> 
                                    <li>Click the small settings icon on the right side of the check </li> 
                                    <li>In the edit form, go to <b>Contact Groups</b> and select the group name of the webhook you created before</li>
                                    <li>Click <b>Save Now</b></li>
								</ol>
							</div>
						</div>
						
					</div>
				)
			break;
			case 'checkly':
				const checkly_image_add_integration_webhook = require(`./../../assets/screenshot/checkly.com--add_integration_webhook.png`)
				return (
					<div className="guide-content">
						<div className="guide-step">
							<div className="guide-step_title">Add Webhook URL to Checkly</div>
							<div className="guide-step_body">
								<div className="screen-image" >
									<Lightbox 
										thumbail={checkly_image_add_integration_webhook}
										image={checkly_image_add_integration_webhook}
									/>
								</div>
								<ol>
									<li><a href="https://app.checklyhq.com/" target="_blanc">Log in to your Checkly account.</a></li>
									<li>Click <b>Alert Settings</b> in the left side menu.</li>
									<li>Find <b>Alert channels</b> section and click on <b>Add more channels</b></li>
									<li>Fin <b>Webhook</b> row and click <b>Add channel</b></li>
									<li>Add the <b>Name</b>, the webhook URL of the component you just copied.</li>
									<li>And in the payload, you must add the <b>status</b> attribute with <b>{`{{ALERT_TYPE}}`}</b> value</li>
									<CodeBlock
								code={`{
	"status": "{{ALERT_TYPE}}",  
	"monitor" : {
		"id" : "{{CHECK_ID}}",
		"name" : "{{CHECK_NAME}}"
	} ,
	"event": "{{ALERT_TITLE}}",
	"link": "{{RESULT_LINK}}",
	"location" : "{{RUN_LOCATION}}"
}`}
								pureCode={`{
	"status": "{{ALERT_TYPE}}",  
	"monitor" : {
		"id" : "{{CHECK_ID}}",
		"name" : "{{CHECK_NAME}}"
	} ,
	"event": "{{ALERT_TITLE}}",
	"link": "{{RESULT_LINK}}",
	"location" : "{{RUN_LOCATION}}"
}`}
								language="json"
									/>
									<li>In <b>Send when</b> section, select <b>a check recovers</b> and <b>a check fails</b></li>
									<li>In the <b>SUBSCRIBERS</b> section, select the check related to the current component</li>
								</ol>
							</div>
						</div>
						
					</div>
				)
			break;
			case 'datadog':
				const datadog_image_add_integration_webhook = require(`./../../assets/screenshot/datadog.com--add_integration_webhook.png`)
				return (
					<div className="guide-content">
						<div className="guide-step">
							<div className="guide-step_title">Add Webhook URL to Datadog</div>
							<div className="guide-step_body">
								<div className="screen-image" >
									<Lightbox 
										thumbail={datadog_image_add_integration_webhook}
										image={datadog_image_add_integration_webhook}
									/>
								</div>
								<ol>
									<li><a href="https://app.datadoghq.com/" target="_blanc">Log in to your Datadog account.</a></li>
									<li>Click <b>Integrations</b> in the left side menu.</li>
									<li>Find <b>Webhook</b> and click on <b>Install</b></li>
									<li>Add the <b>Name</b>, the webhook URL of the component you just copied.</li>
									<li>And in the payload, you must add the <b>status</b> attribute with <b>$ALERT_TRANSITION</b> value</li>
								</ol>
								<CodeBlock
								code={`{
	"status": "$ALERT_TRANSITION", // Required attribute
	"body": "$EVENT_MSG",
	"last_updated": "$LAST_UPDATED",
	"event_type": "$EVENT_TYPE",
	"title": "$EVENT_TITLE",
	"date": "$DATE",
	"org": {
		"id": "$ORG_ID",
		"name": "$ORG_NAME"
	},
	"id": "$ID"
}`}
								pureCode={`{
	"status": "$ALERT_TRANSITION", 
	"body": "$EVENT_MSG",
	"last_updated": "$LAST_UPDATED",
	"event_type": "$EVENT_TYPE",
	"title": "$EVENT_TITLE",
	"date": "$DATE",
	"org": {
		"id": "$ORG_ID",
		"name": "$ORG_NAME"
	},
	"id": "$ID"
}`}
								language="json"
								/>
							</div>
						</div>
						
					</div>
				)
			break;
			case 'uptimerobot':
				const uptimerobot_image_add_integration_webhook = require(`./../../assets/screenshot/uptimerobot.com--add_integration_webhook.png`)
				return (
					<div className="guide-content">
						<div className="guide-step">
							<div className="guide-step_title">Add Webhook URL to UptimeRobot</div>
							<div className="guide-step_body">
								<div className="screen-image" >
									<Lightbox 
										thumbail={uptimerobot_image_add_integration_webhook}
										image={uptimerobot_image_add_integration_webhook}
									/>
								</div>
								<ol>
									<li><a href="https://uptimerobot.com/login?ref=statusway.co" target="_blanc">Log in to your UptimeRobot account.</a></li>
									<li>On the top navbar, click <b>My Settings</b></li>
									<li>Click <b>Add Alert Contact</b> in the right side.</li>
									<li>Select <b>Webhook</b> from Alert Contact Type dropdown</li>
									<li>Add the <b>Friendly Name</b> and the webhook URL of the component you just copied.</li>
									<li>And add the post payload below</li>
								</ol>
								<CodeBlock
								code={`{
	"status": "*alertTypeFriendlyName*" 
	"component_status": "MAJOR-OUTAGE" // [Optional] affected component status ( OPERATIONAL (UP) / DEGRADED-PERFORMANCE / PARTIAL-OUTAGE / MAJOR-OUTAGE ( DOWN) / UNDER-MAINTENANCE )
	"name": "Sample incident name", // [Optional] incident's title 
	"description": "Sample incident description", // [Optional] incident's message 
}`}
                                pureCode={`{
    "status": "*alertTypeFriendlyName*", 
    "component_status": "MAJOR-OUTAGE",
    "name": "Sample incident name", 
    "description": "Sample incident description"
}`}
								language="json"
								/>
							</div>
						</div>
						
					</div>
				)
			break;
			case 'pingdom':
				const pingdom_image_add_integration_webhook = require(`./../../assets/screenshot/pingdom.com--add_integration.png`)
				const pingdom_image_affect_integration_to_uptime_check = require(`./../../assets/screenshot/pingdom.com--affect_integration_to_uptime_check.png`)
				return (
					<div className="guide-content">
						<div className="guide-step">
							<div className="guide-step_title">Add Webhook URL to Pingdom</div>
							<div className="guide-step_body">
								<div className="screen-image" >
									<Lightbox 
										thumbail={pingdom_image_add_integration_webhook}
										image={pingdom_image_add_integration_webhook}
									/>
								</div>
								<ol>
									<li><a href="https://server-monitor.pingdom.com/signin" target="_blanc">Log in to your Pingdom account.</a></li>
									<li>Click <b>Settings</b> in the left side menu.</li>
									<li>Select <b>Integrations</b> from the secondary menu that appears.</li>
									<li>Click <b>Add integration</b> in the top right of the Integrations screen.</li>
									<li>Select <b>Webhook</b> as the Type.</li>
									<li>In the section below, add a name and the webhook URL of the component you just copied.</li>
									<li>Click <b>Save integration</b>.</li>
								</ol>
							</div>
						</div>
						<div className="guide-step">
							<div className="guide-step_title">Affect the webhook integration to uptime check</div>
							<div className="guide-step_body">
								<div className="screen-image" >
									<Lightbox 
										thumbail={pingdom_image_affect_integration_to_uptime_check}
										image={pingdom_image_affect_integration_to_uptime_check}
									/>
								</div>
								<ol>
									<li>Click <b>Home</b> from the left sidebar in Pingdom.</li> 
									<li>Click <b>the Uptime section</b> under Quick product links.</li> 
									<li>Find the Site name (uptime check).</li> 
									<li>Click the small arrow on the right side of the Pingdom check from which you would like to send alerts.</li> 
									<li>Select <b>Edit</b> from the drop down menu.</li> 
									<li>Scroll down to <b>Connect Integrations</b> in the dialogue that appears.</li> 
									<li>Find the <b>Webhook</b>	selection.</li> 
									<li>Select the Webhook you set up earlier.</li> 
									<li>Click <b>Modify check</b> to save your changes.</li> 
								</ol>
							</div>
						</div>
					</div>
				)
			break;
		
			default:
				return (
					<div className="guide-content">
						<div className="guide-step">
							<div className="guide-step_title">Create an automated incident on your page</div>
							<div className="guide-step_body">
								<p>Send a POST request with the following JSON payload to your webhook endpoint that you generated in the previous step.</p>
								<CodeBlock
									code={`{
	"status": "DOWN", // incident status 
	"component_status": "MAJOR-OUTAGE", // [Optional] affected component status ( OPERATIONAL (UP) / DEGRADED-PERFORMANCE / PARTIAL-OUTAGE / MAJOR-OUTAGE ( DOWN) / UNDER-MAINTENANCE )
	"name": "Sample incident name", // [Optional] incident's title 
	"description": "Sample incident description" // [Optional] incident's message 
}`}
									pureCode={`{
	"status": "DOWN",
	"component_status": "MAJOR-OUTAGE",
	"name": "Sample incident name", 
	"description": "Sample incident description"
}`}
									language="json"
									/>
							</div>
						</div>
						<div className="guide-step">
							<div className="guide-step_title">Resolve an incident</div>
							<div className="guide-step_body">
								<p>Send a POST request with the following JSON payload to your webhook endpoint that you generated in the previous step.</p>
								<p>Please note that if you want to resolve a specific incident, you must add the incident name as an attribute in the payload</p>
								<CodeBlock
									code={`{
	"status": "UP", // incident status 
	"name": "Sample incident name", // [Optional] Incident name that you want to resolve it
	"description": "Sample incident description" // [Optional] incident's message
}`}
									pureCode={`{
	"status": "UP",
	"name": "Sample incident name",
	"description": "Sample incident description"
}`}
									language="json"
									/>
							</div>
						</div>
					</div>
				)
				break;
		}
	}


	
	

	
	return (
		<form>
			<div className='component-automation-wrapper'>
				<div className='component'>
					<label htmlFor="">Selected component </label>
					<CustomSelect 
						data={components.map( component => ({
							value : component?.id,
							label : component?.name
						}))}
						onChange={(value) => onChangeComponents( value )}
						value={component}
						className="fluid"
						showIcons={false}
						isSearchable={false}
					/>
					<span className='component-id'>{component?.value}</span>
				</div>

				<div className="monitoring-services">
					<label htmlFor="">Monitoring services</label>
					<ul>
						{
							automateMonitoringService?.filter(x => x.displayed === true )?.map( (service , index) => {
								return(
									<li 
										key={index} 
										className={`monitoring-service-wrapper ${monitorService?.value === service?.value ? 'active' : ''} ${service.is_active === false ? 'disabled' : ''}`}
										onClick={() => {
											service.is_active === true && setMonitorService(service)
										}}>
										<div className="monitoring-service-item">
											<div className="ms-icon">{service?.image}</div>
											<div className="ms-name">{service?.label}</div>
											<p className="ms-desc">{service?.description}</p>
										</div>
									</li>
								)
							})
						}
					</ul>
				</div>

				<div className="generated-custom-webhook-url">
					<label htmlFor="">Copy the following component's Webhook URL</label>	
					<div className="custom-webhook-url">
						<div className="url-content">{ 
							isLoadingGeneratingWebhookURL === true 
							? 'Generating...'
							: custom_webhook_url }</div>
						<Tooltip
							placement="top" 
							trigger={['hover']} 
							overlay={<span>{`Click here to copy the Webhook URL`}</span>}
							>
							<Button
								loading={isLoadingGeneratingWebhookURL}
								onClick={() => copyWebhookURL(custom_webhook_url)}
							>{
								state.value !=='' && recentlyCopied === true 
								? <FiCheck />
								: <FiCopy />
								}</Button>

						</Tooltip>
					</div>		
				</div>		
				{/* THE SETUP GUIDE TO INTEGRATE THE WEBHOOK URL IN THE USER MONITORING SERVICE */}
				<div className="setup-guide">
					<WebhookGuide source={monitorService?.value}/>
				</div>
			</div>
		</form>
	)
}

